<style lang="scss" scoped>
.project {
  .project-title {
    margin-bottom: 30px;
    h4 {
      font-weight: 600;
    }
  }
  .project-title.project-employee-title {
    margin-top: 25px;
  }
  .create-form-project {
    width: 100%;

    .form-group {
      margin-bottom: 0;
    }

    .form-field {
      margin-bottom: 25px;
    }

    label {
      font-weight: 600;
    }

    .required {
      color: #ff1a1a;
    }

    .add-employee {
      clear: both;
      margin-left: 14px;
    }

    .btn-delete-employee {
      margin-left: 10px;
      cursor: pointer;
    }

    .information-employee {
      position: relative;
      clear: both;
    }

    .require {
      color: #ff1a1a;
    }

    .btn-add-employee {
      clear: both;
      .btn-add-new label {
        color: #f6ab5f;
        font-size: 1rem;
        cursor: pointer;
      }
    }

    .project.button {
      clear: both;
      margin: 30px 0 50px 0;

      .save-project {
        background: #b4daf3;
        font-weight: 600;
        padding: 7px 70px;
        color: #0d2e48;
        border: 2px solid #b4daf3;
        margin-right: 20px;
      }

      .cancel-project {
        padding: 7px 45px;
        font-weight: 600;
        background: #f6f6f6;
        border: 2px solid #0d2e48;
        color: #0d2e48;
        max-width: 300px;
      }
    }

    .btn-add-range-time {
      label{
        cursor: pointer;
      }
    }
  }
}

@media screen and (max-width: 767px) {
  .create-form-project {
    margin-right: 0;

    .save-project {
      width: 100%;
      margin: 0.8rem 0;
    }

    .cancel-project {
      width: 100%;
      max-width: 100% !important;
    }
    .information-employee {
      .delete-employee {
        right: 0%;
      }
    }
    .project.button {
      margin: 0 0 50px 0 !important;
    }
  }
}
</style>
<template>
  <div class="project">
    <CRow>
      <CCol md="12" sm="12" class="project-title">
        <h4>{{ $t("project.create_project") }}</h4>
      </CCol>
    </CRow>
    <CRow>
      <CCol md="12" sm="12">
        <ValidationObserver ref="formCreateProject" v-slot="{ handleSubmit }">
          <CForm
            class="create-form-project"
            @submit.prevent="handleSubmit(submitProject)"
          >
            <!-- line 1-->
            <CRow>
              <CCol md="3" sm="12" class="form-field">
                <label>
                  {{ $t("project.name_project") }}
                </label>
                <CInput type="text" v-model="form.name" maxlength="255"/>
              </CCol>
                <CCol md="3" sm="12" class="form-field">
                    <label>
                        {{ $t("project.customer") }}
                    </label>
                    <Select2
                        class="select2-custom"
                        v-model="form.customer_id"
                        :options="customers"
                    />
                </CCol>
              <CCol md="3" sm="12" class="form-field">
                <label>
                  {{ $t("project.project_type") }}
                </label>
                <select class="form-control form-group" v-model="form.project_type">
                  <option value="">{{ $t("employee.select_option") }}</option>
                  <option
                    v-for="(option, index) in types"
                    :key="index"
                    :value="option.code"
                  >
                    {{ option.name }}
                  </option>
                </select>
              </CCol>
              <CCol md="3" sm="12" class="form-field">
                  <label>{{ $t("project.contract_value") }}</label>
                  <CInput type="text" v-model="form.contract_value" />
              </CCol>
            </CRow>
            <!-- line 2-->
            <CRow>
              <CCol md="3" sm="12" class="form-field">
                <label>
                  {{ $t("employee.label_develop_division") }}
                </label>
                <select class="form-control form-group" v-model="form.department_code">
                  <option value="">{{ $t("employee.select_option") }}</option>
                  <option
                    v-for="(option, index) in divisions"
                    :key="index"
                    :value="option.code"
                  >
                    {{ option.name }}
                  </option>
                </select>
              </CCol>
              <CCol md="3" sm="12" class="form-field">
                <label>
                  {{ $t("employee.label_quality_division") }}
                </label>
                <select class="form-control form-group" v-model="form.department_test">
                  <option value="">{{ $t("employee.select_option") }}</option>
                  <option
                    v-for="(option, index) in qualityDivisions"
                    :key="index"
                    :value="option.code"
                  >
                    {{ option.name }}
                  </option>
                </select>
              </CCol>
                <CCol md="3" sm="12" class="date form-field">
                    <label>
                        {{ $t("project.start_date") }}
                    </label>
                    <DatePickerFormFlex
                        :propsDate="form.start_date"
                        @emitDate="startDate"
                        v-model="form.start_date"
                    />
                </CCol>
                <CCol md="3" sm="12" class="date form-field">
                    <label>
                        {{ $t("project.end_date") }}
                    </label>
                    <DatePickerFormFlex
                        :propsDate="form.end_date"
                        @emitDate="endDate"
                        v-model="form.end_date"
                    />
                </CCol>
            </CRow>
            <!-- line 3-->
            <CRow>
              <CCol md="3" sm="12" class="form-field">
                <label>
                  {{ $t("employee.label_project_status") }}
                </label>
                <select class="form-control form-group" v-model="form.status">
                  <option value="">{{ $t("employee.select_option") }}</option>
                  <option
                    v-for="(option, index) in status"
                    :key="index"
                    :value="option.code"
                  >
                    {{ option.name }}
                  </option>
                </select>
              </CCol>
              <CCol md="3" sm="12" class="form-field">
                <label>
                  {{ $t("employee.label_project_description") }}
                </label>
                <CTextarea v-model="form.description"/>
              </CCol>
            </CRow>
            <!-- line 4-->
            <CRow>
              <CCol
                md="12"
                sm="12"
                class="project-title project-employee-title"
              >
                <h4>{{ $t("project.add_employee") }}</h4>
              </CCol>
            </CRow>
            <CRow v-for="(item, index) in form.employee_project" :key="index">
              <CCol md="2" sm="12" class="form-field">
                <label>
                  {{ $t("project.employee") }}
                </label>
                <Select2
                  class="select2-custom"
                  v-model="form.employee_project[index].employee_id"
                  :options="employee_list"
                />
              </CCol>
              <CCol md="2" sm="12" class="form-field">
                <label>
                  {{ $t("project.employee_type") }}
                </label>
                <select
                  class="form-control form-group"
                  v-model="form.employee_project[index].employee_type"
                >
                  <option value="">{{ $t("employee.select_option") }}</option>
                  <option
                    v-for="(option, index) in employee_position"
                    :key="index"
                    :value="option.code"
                  >
                    {{ option.name }}
                  </option>
                </select>
              </CCol>
              <CCol md="2" sm="12" class="form-field">
                <label>
                  {{ $t("project.label_project_member_start_date") }}
                </label>
                <DatePickerFormFlex
                  :propsDate="
                    form.employee_project[index].member_project_start_date
                  "
                  @emitDate="memberProjectStartDate($event, index)"
                  v-model="
                    form.employee_project[index].member_project_start_date
                  "
                />
              </CCol>
              <CCol md="2" sm="12" class="form-field">
                <label>
                  {{ $t("project.label_project_member_end_date") }}
                </label>
                <DatePickerFormFlex
                  :propsDate="form.employee_project[index].member_project_end_date"
                  @emitDate="memberProjectEndDate($event, index)"
                  v-model="form.employee_project[index].member_project_end_date"
                />
              </CCol>
              <CCol md="1" sm="12" class="form-field">
                <label>{{ $t("project.effort") }}</label>
                <div class="d-flex align-items-center">
                  <CInput type="text" v-model="form.employee_project[index].employee_effort" />
                  <div v-if="form.employee_project.length > 1" @click="deleteEmployeeFromProject(index)" class="delete-btn">
                    <CIcon name="cilTrash" class="btn-delete-employee" />
                  </div>
                </div>
              </CCol>

              <template class="form-field btn-add-employee" v-for="(itemManTime, indexManTime) in form.employee_project[index].employee_range_time">
                <CCol md="2" sm="12" class="form-field" :key="`g + ${index + indexManTime}`"></CCol>
                <CCol md="2" sm="12" class="form-field" :key="`a + ${index + indexManTime}`"></CCol>
                <CCol md="2" sm="12" class="form-field" :key="`b + ${index + indexManTime}`"></CCol>
                <CCol md="2" sm="12" class="form-field" :key="`c + ${index + indexManTime}`">
                  <label>
                    {{ $t("project.label_project_member_start_date") }}
                  </label>
                  <ValidationProvider
                      :rules="`required|startDateCustomRule:${form.employee_project[index].member_project_end_date},${indexManTime>0 ? form.employee_project[index].employee_range_time[(indexManTime-1)].member_project_end_date : ''},${indexManTime}`"
                      v-slot="{ errors }"
                      :name="$t('project.label_project_member_start_date') + (indexManTime + 1)"
                  >
                    <DatePickerFormFlex
                      :propsDate="form.employee_project[index].employee_range_time[indexManTime].member_project_start_date"
                      @emitDate="rangeTimeStartDate($event, index, indexManTime)"
                      v-model="form.employee_project[index].employee_range_time[indexManTime].member_project_start_date"
                    />
                    <span class="required">{{$t(errors[0])}}</span>
                  </ValidationProvider>
                </CCol>
                <CCol md="2" sm="12" class="form-field" :key="`d + ${index + indexManTime}`">
                  <label>
                    {{ $t("project.label_project_member_end_date") }}
                  </label>
                  <ValidationProvider
                      :rules="`required|endDateCustomRule:${form.employee_project[index].employee_range_time[indexManTime].member_project_start_date}`"
                      v-slot="{ errors }"
                      :name="$t('project.member_project_end_date') + (indexManTime + 1)"
                  >
                    <DatePickerFormFlex
                      :propsDate="form.employee_project[index].employee_range_time[indexManTime].member_project_end_date"
                      @emitDate="rangeTimeEndDate($event, index, indexManTime)"
                      v-model="form.employee_project[index].employee_range_time[indexManTime].member_project_end_date"
                    />
                    <span class="required">{{$t(errors[0])}}</span>
                  </ValidationProvider>
                </CCol>
                <CCol md="1" sm="12" class="form-field" :key="`e + ${index + indexManTime}`">
                  <label>{{ $t("project.effort") }}</label>
                  <div class="d-flex align-items-center">
                    <CInput type="text" v-model="form.employee_project[index].employee_range_time[indexManTime].effort" />
                    <div v-if="form.employee_project[index].employee_range_time.length > 0" md="1" class="btn-delete-employee" @click="deleteRangeTime(indexManTime, index)" :key="`f + ${index + indexManTime}`">
                      <CIcon name="cilTrash" class="delete-btn" />
                    </div>
                  </div>
                </CCol>

              </template>
              <CCol md="12" class="form-field btn-add-range-time" sm="12">
                <label @click="addEmployeeRangeTime(index)">+ {{$t('project.add_range_time')}}</label>
              </CCol>
            </CRow>
            <CRow>
              <CCol md="12" sm="12" class="form-field btn-add-employee">
                <div class="btn-add-new">
                  <label @click="addEmployeeToProject()"
                    >+ {{ $t("project.add_employee") }}</label
                  >
                </div>
              </CCol>
            </CRow>
            <CRow class="justify-content-center">
              <CCol md="12" sm="12" class="project button text-center">
                <CButton type="submit" class="save-project">{{
                  $t("label.save_infomation")
                }}</CButton>
                <CButton
                  class="cancel-project"
                  type="button"
                  @click="cancel()"
                  >{{ $t("project.cancel_create_project") }}
                </CButton>
              </CCol>
            </CRow>
          </CForm>
        </ValidationObserver>
      </CCol>
    </CRow>
  </div>
</template>

<script>
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { mapGetters, mapActions } from "vuex";
import "sweetalert2/src/sweetalert2.scss";
import DatePickerFormFlex from "../../components/Common/DatePickerFormFlex";

export default {
  metaInfo() {
    return {
      title: this.$t("page_title.page_project_create"),
      titleTemplate: "%s | " + this.$t("page_title.head_title")
    };
  },

  components: {
    ValidationObserver,
    ValidationProvider,
    DatePickerFormFlex
  },

  async created() {
    await this.$store.dispatch("project/getCommonsData");
  },

  computed: {
    ...mapGetters({
      employees: "project/employees",
      customers: "project/customers",
      foots: "commons/foots",
      divisions: "commons/divisions",
      employee_position: "project/employee_position",
      developDivisions: "commons/developDivisions",
      qualityDivisions: "commons/qualityDivisions",
    }),
  },

  data() {
    return {
      employee_skill: [],
      employee_list: [],
      status: [
        {"code": "TODO", "name": "Sắp triển khai"},
        {"code": "DOING", "name": "Đang triển khai"},
        {"code": "DONE", "name": "Đã hoàn thành"}
      ],
      types: [
        {"code": "SPOT", "name": "Spot"},
        {"code": "LABO", "name": "Labo"},
        {"code": "MAINTAIN", "name": "Maintain"},
        {"code": "OTHER", "name": "Other"},
      ],
      form: {
        name: "",
        customer_id: "",
        project_type: "",
        start_date: Intl.DateTimeFormat("en-GB").format(new Date()),
        end_date: Intl.DateTimeFormat("en-GB").format(new Date()),
        contract_value: "",
        department_code: "",
        department_test: "",
        status: "",
        description: "",
        employee_project: [
          {
            employee_id: "",
            employee_type: "",
            employee_skill: "",
            member_project_start_date: Intl.DateTimeFormat("en-GB").format(new Date()),
            member_project_end_date: Intl.DateTimeFormat("en-GB").format(new Date()),
            employee_effort:"",
            employee_range_time:[],
          }
        ]
      }
    };
  },

  methods: {
    ...mapActions("layout", ["setLoading"]),
    
    startDate(data) {
      this.form.start_date = data;
      this.form.employee_project.forEach(element => {
        element.member_project_start_date = this.form.start_date;
      });
    },

    endDate(data) {
      this.form.end_date = data;
      this.form.employee_project.forEach(element => {
        element.member_project_end_date = this.form.end_date;
      });
    },

    memberProjectStartDate(data, index) {
      this.form.employee_project[index].member_project_start_date = data;
    },

    memberProjectEndDate(data, index) {
      this.form.employee_project[index].member_project_end_date = data;
    },

    rangeTimeStartDate(data, index, indexRangeTime) {
      this.form.employee_project[index].employee_range_time[indexRangeTime].member_project_start_date = data;
    },

    rangeTimeEndDate(data, index, indexRangeTime) {
      this.form.employee_project[index].employee_range_time[indexRangeTime].member_project_end_date = data;
    },

    async submitProject() {
      this.setLoading(true);
      await this.$store
        .dispatch("project/createProject", this.form)
        .then(() => {
          let message = this.$t("project.popup.create_project_success");
          this.$toast(message, null, 2000, "b-toaster-top-center", "success");
          this.$router.push({ path: "/projects" });
          this.setLoading(false);
        })
        .catch(() => {
          this.setLoading(false);
        });
    },

    addEmployeeToProject() {
      this.form.employee_project.push({
        employee_id: "",
        employee_type: "",
        employee_skill: "",
        member_project_start_date: this.form.start_date,
        member_project_end_date: this.form.end_date,
        employee_range_time: [],
      }) ;
    },

    addEmployeeRangeTime(indexEmployee) {
      this.form.employee_project[indexEmployee].employee_range_time.push({
        member_project_start_date: this.form.start_date,
        member_project_end_date: this.form.end_date,
        effort:"",
      });
    },

    deleteEmployeeFromProject(index) {
      console.log("aaaa");
      this.form.employee_project.splice(index, 1);
    },

    deleteRangeTime(indexRangeTime, indexEmployee) {
      this.form.employee_project[indexEmployee].employee_range_time.splice(indexRangeTime, 1);
    },

    cancel() {
      this.$confirm(
        this.$t("project.cancel_create_project"),
        this.$t("popup.employee.label_popup_title"),
        this.$t("popup.employee.label_confirm_button"),
        this.$t("popup.employee.label_cancel_button"),
        "danger"
      ).then(value => {
        if (value) {
          this.$router.push({ path: "/projects" });
        }
      });
    },

    async onChangeEmployee(employeeId, index) {
      this.setLoading(true);
      await this.$store
        .dispatch("project/getEmployeeSkill", employeeId)
        .then((response) => {
            this.$set(this.employee_skill, index, response.data.employee_skill);
            this.setLoading(false);
        })
        .catch(() => {
            this.setLoading(false);
      });
    }
  },

  watch: {
    employees(employeeList) {
      this.employee_list = employeeList.map((employee)=> { 
        let splitSpaceString = employee.text.split(" ");
        let newStringEmail = splitSpaceString[splitSpaceString.length-1];
        let newStringName = splitSpaceString[splitSpaceString.length-2];
        let newArray = ((splitSpaceString.slice(0, splitSpaceString.length-2)).map(([i]) =>i)).join('');
        let numberPattern = /\d+/g;
        if(newStringEmail.match(numberPattern)=== null){
          return {
            id: employee.id,
            text: employee.name + " (" + newStringName + " " + newArray + ")"
          }
        }
        else {
          return {
            id: employee.id,
            text: employee.name + " (" + newStringName + " " + newArray + newStringEmail.match(numberPattern) + ")"
          }
        }
      })
    }
  }
};
</script>

<style>
.delete-btn {
  color: red;
}

.select2-custom .select2-selection {
  font-size: 0.875rem;
  font-weight: 400;
  padding: 0.375rem 0.75rem;
  height: calc(1.5em + 0.75rem + 2px);
  display: block;
  line-height: 1.5;
  background-clip: padding-box;
  border: 1px solid #d8dbe0;
  color: #768192;
  background-color: #fff;
  border-radius: 0.25rem;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}

.select2-custom .select2-selection:focus {
  color: #768192;
  background-color: #fff;
  border-color: #958bef;
  outline: 0;
  box-shadow: 0 0 0 0.2rem rgba(50, 31, 219, 0.25);
}

.select2-container {
  width: 100% !important;
}
.btn-add-new label {
  color: #f6ab5f;
  font-size: 1rem;
  cursor: pointer;
  margin-left: 0px;
}
</style>
